import * as React from 'react';

import { BodyRow } from './BodyRow';
import { DataGrid } from './DataGrid';

import { Dictionary } from './Utils';
import { GridSelection } from './GridSelection';

export class BodySection extends React.PureComponent<BodySection.Props> {

  public static displayName: string = 'DataGridBodySection';

  private measuredColumnWidths: Dictionary<number> = {};

  public componentDidMount(): void {
    this.reportMeasuredColumnWidths();
  }

  public componentDidUpdate(): void {
    this.reportMeasuredColumnWidths();
  }

  private reportMeasuredColumnWidths(): void {
    if (this.props.measureColumnWidths && Object.keys(this.measuredColumnWidths).length > 0) {
      const measuredColumnWidths = { ...this.measuredColumnWidths };
      this.measuredColumnWidths = {};
      this.props.measureColumnWidths(measuredColumnWidths);
    }
  }

  private handleReportCellWidthFn = (columnKey: string, width: number) => {
    if (this.props.measureColumnWidths && this.props.measuredColumnWidths[columnKey] === undefined) {
      this.measuredColumnWidths[columnKey] = Math.max(width, this.measuredColumnWidths[columnKey] || 0);
    }
  }

  private isRowSelected(row: DataGrid.Row, rowIdx: number): boolean {
    if (!row || !this.props.selectionModel) {
      return false;
    }
    return this.props.selectionModel.isSelected({ colIdx: -1, rowIdx, rowKey: row.key });
  }

  public render(): JSX.Element {
    // tslint:disable-next-line:no-any
    let rowElements: React.ReactElement<any>[] = [];

    for (let i = this.props.rowStartIdx; i <= this.props.rowEndIdx; i++) {
      let row = this.props.rows[i];
      let isRowSelected = this.isRowSelected(row, i);

      rowElements.push(<BodyRow {...{
        key: i,
        row: row,
        rowIdx: i,
        colStartIdx: this.props.colStartIdx,
        colEndIdx: this.props.colEndIdx,
        cols: this.props.cols,
        columnWidths: this.props.columnWidths,
        onCellClick: this.props.onCellClick,
        onCellDoubleClick: this.props.onCellDoubleClick,
        onCellContextMenu: this.props.onCellContextMenu,
        onRowHeaderCellClick: this.props.onRowHeaderCellClick,
        isSelected: isRowSelected,
        selectionModel: this.props.selectionModel,
        selectionTimestamp: this.props.selectionTimestamp,
        showRowBanding: this.props.showRowBanding,
        showHorizontalGridLines: this.props.showHorizontalGridLines,
        showVerticalGridLines: this.props.showVerticalGridLines,
        leftMargin: this.props.leftMargin,
        measuredColumnWidths: this.props.measuredColumnWidths,
        reportWidthFn: this.handleReportCellWidthFn,
        rowOuterHeight: this.props.rowOuterHeight
      }} />);
    }

    return (
      <div role='rowgroup' className='tb-react-dg-bsection'>
        {rowElements}
      </div>
    );
  }

}

export namespace BodySection {

  export interface Props {
    cols: DataGrid.Column[];
    rows: DataGrid.Row[];

    /** first and last columns to render (for paging) */
    colStartIdx: number;
    colEndIdx: number;

    /** first and last rows to render (for paging) */
    rowStartIdx: number;
    rowEndIdx: number;

    onCellClick?: DataGrid.ClickHandler;
    onCellDoubleClick?: DataGrid.ClickHandler;
    onCellContextMenu?: DataGrid.ClickHandler;

    onRowHeaderCellClick?: (rowIdx: number, e: React.MouseEvent<HTMLDivElement>) => void;

    selectionModel?: GridSelection;
    selectionTimestamp?: number;

    showRowBanding?: boolean;
    showHorizontalGridLines?: boolean;
    showVerticalGridLines?: boolean;
    leftMargin?: number;

    columnWidths?: DataGrid.ColumnWidths;
    measuredColumnWidths: Dictionary<number>;

    // tslint:disable-next-line:no-any
    measureColumnWidths?: (colWidths: Dictionary<number>) => any;

    rowOuterHeight: number;
  }

}
